<div style="width: 200px;">
    <div class="header color"></div>
    <div class="header-text" style="border: 2px solid #F39205; border-radius: 0px 0px 10px 10px;">
        <div class="text">
            <p style="width: 112px">
                Bien assurer son emprunt immobilier
            </p>
        </div>
        <div class="title" style="margin-bottom: 13px;">
            GROUPAMA EMPRUNTEUR
        </div>
        <div class="text" style="margin-bottom: 5px">
            <p style="width: 117px;">
                Réaliser jusqu'à 15 000€ d'économies(2) en choisissant Groupama pour votre assurance de prêt
            </p>
        </div>
        <div style="display: flex;justify-content: center;flex-direction: column;align-items: center">
            <div>
                <img alt="" src="assets/img/preco/telephone.svg" style="width: 130px">
            </div>
            <div style="cursor: pointer">
                <img src="assets/img/preco/simul-tarif.svg" style="width: 130px" (click)="openSimulateur()">
            </div>
        </div>
    </div>
</div>

